import { SignupComponent } from './signup/signup.component';
import { ResidentialComponent } from '../home-main/solution/residential/residential.component';
import { GetStartedComponent } from '../get-started/get-started.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SkippageComponent } from './skippage/skippage.component';
import { QuestionnaireResidentialComponent } from './questionnaire-residential/questionnaire-residential.component';
import { SignupOptionsComponent } from './signup-options/signup-options.component';
import { SuccessComponent } from './questionnaire-residential/success/success.component';
import { PreSuccessComponent } from './questionnaire-residential/pre-success/pre-success.component';
import { RecommendationComponent } from './questionnaire-residential/recommendation/recommendation.component';
import { InitialOptionsComponent } from './questionnaire-residential/recommendation/initial-options/initial-options.component';
import { CompareProductComponent } from './questionnaire-residential/recommendation/compare-product/compare-product.component';
import { SingleProductComponent } from './questionnaire-residential/recommendation/single-product/single-product.component';
import { SignupOrderComponent } from './questionnaire-residential/signup-order/signup-order.component';
import { PreCongratsComponent } from './questionnaire-residential/pre-congrats/pre-congrats.component';
import { CongratsComponent } from './questionnaire-residential/congrats/congrats.component';
import { EnergyplanConfirmationComponent } from './questionnaire-residential/energyplan-confirmation/energyplan-confirmation.component';
import { SsnCheckComponent } from './questionnaire-residential/signup-order/ssn-check/ssn-check.component';
import { SSnopenwithdepositComponent } from './questionnaire-residential/signup-order/ssn-check/ssn-openwithdeposit.component';
import { DepositRequiredComponent } from './questionnaire-residential/signup-order/ssn-check/depositrequired.component';
import { CreditCheckFurutherActionComponent } from './questionnaire-residential/signup-order/ssn-check/creditcheck-furtheraction.component';
import { ServiceDeniedComponent } from './questionnaire-residential/signup-order/ssn-check/service-denied.component';
import { ThankyouComponent } from './questionnaire-residential/signup-order/ssn-check/thankyou.component';
import { PrepaidConfirmationComponent } from './questionnaire-residential/pre-paid-success/prepaid-confirmation.component';
import { StatusLoading } from './questionnaire-residential/status-loading/status-loading.component';
import { DepositRequired4CEComponent } from './questionnaire-residential/signup-order/ssn-check/depositrequired4CE.component';
import { DepositRequiredBKVComponent } from './questionnaire-residential/signup-order/ssn-check/depositrequiredBKV.component';
import { ProductComparisonComponent } from './questionnaire-residential/recommendation/product-comparison/product-comparison.component';
// import { ErrorDialogComponent } from './questionnaire-residential/error-dialog/error-dialog.component';

const routes: Routes = [
  { path: 'skippage', component: SkippageComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'residential', component: ResidentialComponent },
  { path: 'getstarted', component: GetStartedComponent },
  { path: 'residentialQues', component: QuestionnaireResidentialComponent },
  { path: 'prepaidoption/:id', component: PrepaidConfirmationComponent },
  { path: 'success', component: SuccessComponent },
  { path: 'pre-success', component: PreSuccessComponent },
  { path: 'recommendation/:hg_accountId', component: InitialOptionsComponent },
  {
    path: 'recommendation/single-product/:id',
    component: SingleProductComponent,
  },
  // {
  //   path: 'recommendation/compare-product/:id',
  //   component: ProductComparisonComponent,
  // },
  {
    path: 'recommendation/compare-product/:id',
    component: CompareProductComponent,
  },
  {
    path: 'signup/recommendation/:hg_accountId',
    redirectTo: 'recommendation/:hg_accountId',
  },
  {
    path: 'login/recommendation/:hg_accountId',
    redirectTo: 'recommendation/:hg_accountId',
  },
  { path: 'pre-congrats/:hg_accountId', component: PreCongratsComponent },
  { path: 'signuporder/:hg_accountId', component: SignupOrderComponent },
  { path: 'congrats/:hg_accountId', component: CongratsComponent },
  {
    path: 'energyplan-confirmation/:hg_accountId',
    component: EnergyplanConfirmationComponent,
  },
  { path: 'ssn-check/:hg_accountId', component: SsnCheckComponent },
  {
    path: 'depositrequired/:hg_accountId',
    component: DepositRequiredComponent,
  },
  {
    path: 'openwithdeposit/:hg_accountId',
    component: SSnopenwithdepositComponent,
  },
  {
    path: 'creditcheck-furtheraction/:hg_accountId',
    component: CreditCheckFurutherActionComponent,
  },
  { path: 'service-denied/:hg_accountId', component: ServiceDeniedComponent },
  { path: 'thankyou/:hg_accountId', component: ThankyouComponent },
  { path: 'status-loading/:hg_accountId', component: StatusLoading },
  {
    path: 'depositrequired4ce/:hg_accountId',
    component: DepositRequired4CEComponent,
  },
  {
    path: 'depositrequiredbkv/:hg_accountId',
    component: DepositRequiredBKVComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuestionarieSignupRoutingModule {}
